import React from "react";
import FileWhite from "../icons/file-white.svg";
import FileGrey from "../icons/file-grey.svg";

const OtherDetailStepIcon = ({ show, completed }) => {
  const iconSrc = show || completed ? FileWhite : FileGrey;

  return (
    <div className="stepLeft">
      <img
        src={iconSrc}
        alt="File Step Icon"
        // style={{ height: 24, width: 24 }}
      />
    </div>
  );
};

export default OtherDetailStepIcon;
